import * as waybillDataTypes from '../types/WaybillData';
import * as modalTypes from '../types/Modal';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case waybillDataTypes.WAYBILL_DATA_UPDATE_NUMBER_VALUE:
            return {
                ...state,
                newNumber: action.waybillNumber,
                canSave: action.canSave
            };
        case waybillDataTypes.WAYBILL_DATA_UPDATE_COURIER_VALUE:
            return {
                ...state,
                waybillCourier: action.payload,
                canSave: true
            };
        case modalTypes.HIDE_MODAL:
            return INITIAL_STATE;
        case modalTypes.SHOW_MODAL:
            return {
                ...state,
                newNumber:action.modalProps.waybillNumber,
                waybillCourier: action.modalProps.waybillCourier
            };
    }
    return state;
}

const INITIAL_STATE = {
    newNumber: '',
    waybillCourier: {
        value: 'NotSpecified',
        displayName: 'Nieokreślony'
    },
    canSave: false
};


// WEBPACK FOOTER //
// ./src/reducers/WaybillData.js